<mdb-form-control class="form-fill">
  <input
    mdbInput
    [formControl]="control"
    [mdbDatepicker]="datepicker"
    type="text"
    class="form-control form-control--paybee" 
    [id]="id"
    [readonly]="true"
    (click)="datepicker.open()"
  />
  <label mdbLabel [for]="id" class="form-label form-label--paybee">{{label}}</label>
  <mdb-datepicker-toggle [mdbDatepicker]="datepicker"></mdb-datepicker-toggle>
  <mdb-datepicker
    [format]="myDatePickerOptions.dateFormat"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [startDate]="startDate"
    [inline]="false"
    #datepicker
  ></mdb-datepicker>
</mdb-form-control>
